(function () {
  "use strict";

  // הגדרות בסיס
  const VIEW_KEY = "rs_sport_view_pref";
  const LOADER_VERSION = "v9_stable";
  let isLoading = false;

  // --- זיהוי שפה + מילון תרגומים ---
  const getLang = () => {
    const htmlLang = (document.documentElement.getAttribute("lang") || "").toLowerCase();
    if (htmlLang) return htmlLang.split("-")[0];
    return "he";
  };

  const I18N = {
    he: {
      loading: "טוען...",
      seen: (visible, total) => `צפית ב ${visible} מוצרים מתוך ${total}`
    },
    ar: {
      loading: "جار التحميل...",
      seen: (visible, total) => `شاهدت ${visible} منتج من أصل ${total}`
    },
    en: {
      loading: "Loading...",
      seen: (visible, total) => `You've seen ${visible} products out of ${total}`
    },
    es: {
      loading: "Cargando...",
      seen: (visible, total) => `Has visto ${visible} productos de ${total}`
    },
    ru: {
      loading: "Загрузка...",
      seen: (visible, total) => `Вы просмотрели ${visible} товаров из ${total}`
    }
  };

  const t = (key, ...args) => {
    const lang = getLang();
    const pack = I18N[lang] || I18N.he;
    const value = pack[key];
    if (typeof value === "function") return value(...args);
    return value || "";
  };

  // --- עזרים ---
  const getGrid = () => document.querySelector(".product-list__inner");
  const getContainer = () => document.querySelector("product-facet");
  const getButton = () => document.querySelector('[data-load-more-trigger]');

  // --- הזרקת CSS מינימלי פעם אחת לספינר מודרני ---
  const injectLoaderStylesOnce = () => {
    if (document.getElementById("rs-loadmore-style")) return;

    const style = document.createElement("style");
    style.id = "rs-loadmore-style";
    style.textContent = `
      @keyframes rsSpin { to { transform: rotate(360deg); } }
      .rs-loadmore__spinner {
        width: 16px;
        height: 16px;
        display: inline-block;
        vertical-align: middle;
        margin-inline-end: 8px;
        animation: rsSpin 0.8s linear infinite;
      }
      .rs-loadmore__spinner circle {
        stroke: currentColor;
        opacity: 0.9;
      }
      .rs-loadmore__label {
        display: inline-block;
        vertical-align: middle;
      }
    `;
    document.head.appendChild(style);
  };

  const getLoadingHTML = () => {
    return `
      <svg class="rs-loadmore__spinner" viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="9" fill="none" stroke-width="2.5" stroke-linecap="round" stroke-dasharray="42 18"></circle>
      </svg>
      <span class="rs-loadmore__label">${t("loading")}</span>
    `;
  };

  // --- פונקציה לייצוב ה URL של הכפתור (סינכרון פילטרים) ---
  const syncButtonUrl = () => {
    const btn = getButton();
    if (!btn) return;

    try {
      const href = btn.getAttribute("href");
      if (!href) return;

      const currentParams = new URLSearchParams(window.location.search);
      const btnUrl = new URL(href, window.location.origin);

      currentParams.forEach((value, key) => {
        if (key !== "page") btnUrl.searchParams.set(key, value);
      });

      btn.setAttribute("href", btnUrl.pathname + btnUrl.search);
    } catch (e) {
      console.warn("Error syncing button URL", e);
    }
  };

  // --- פונקציה ליישום עיצוב (ללא ריצוד) ---
  const applyView = () => {
    const grid = getGrid();
    const container = getContainer();
    const savedView = localStorage.getItem(VIEW_KEY) || "2";

    // עדכון כפתורי הסוויצר
    const viewButtons = document.querySelectorAll(".view-btn");
    viewButtons.forEach((btn) => {
      const isActive = btn.dataset.view === savedView;
      if (btn.classList.contains("active") !== isActive) {
        btn.classList.toggle("active", isActive);
      }
    });

    if (!grid) return;

    // רק במובייל נוגעים ב DOM
    if (window.innerWidth <= 740) {
      if (container && container.getAttribute("data-mobile-view") !== savedView) {
        container.setAttribute("data-mobile-view", savedView);
      }

      if (savedView === "1") {
        grid.classList.add("view-1-col");
        grid.classList.remove("view-2-col");
      } else {
        grid.classList.add("view-2-col");
        grid.classList.remove("view-1-col");
      }
    } else {
      grid.classList.remove("view-1-col", "view-2-col");
      if (container) container.removeAttribute("data-mobile-view");
    }
  };

  // --- עדכון טקסט כמה מוצרים נצפו ---
  const updateCountText = () => {
    const totalEl = document.querySelector(".product-facet__meta-bar-item--count");
    if (!totalEl) return;

    const total = totalEl.innerText.replace(/\D/g, "") || "0";
    const visible = document.querySelectorAll(".product-list__inner .product-item").length;
    const statusDiv = document.getElementById("product-count-status");

    if (statusDiv) statusDiv.innerText = t("seen", visible, total);
  };

  // --- טעינת עמוד הבא ---
  const fetchNextPageDoc = async (url) => {
    const response = await fetch(url, { credentials: "same-origin" });
    if (!response.ok) throw new Error("Network response was not ok");
    const text = await response.text();
    return new DOMParser().parseFromString(text, "text/html");
  };

  // --- המנוע טעינת מוצרים ---
  const loadMoreProducts = async (e) => {
    e.preventDefault();

    const btn = getButton();
    const grid = getGrid();
    if (!btn || !grid || isLoading) return;

    const url = btn.getAttribute("href");
    if (!url) return;

    injectLoaderStylesOnce();

    // התחלת טעינה
    isLoading = true;
    btn.classList.add("is-loading");
    btn.setAttribute("aria-busy", "true");

    const originalHTML = btn.innerHTML;
    btn.innerHTML = getLoadingHTML();

    try {
      const doc = await fetchNextPageDoc(url);

      // מוצרים חדשים
      const newItems = doc.querySelectorAll(".product-list__inner .product-item");
      if (newItems && newItems.length) {
        const fragment = document.createDocumentFragment();

        // clone כדי למנוע דברים מוזרים עם מאזינים או DOM פנימי של התבנית
        newItems.forEach((item) => fragment.appendChild(item.cloneNode(true)));

        // append אחד בלבד כדי לצמצם reflow
        grid.appendChild(fragment);
      }

      // עדכון pagination בצורה יציבה
      const nextPagination = doc.querySelector('[id^="ajax-pagination-"]');
      const paginationContainer = document.querySelector('[id^="ajax-pagination-"]');

      if (paginationContainer) {
        if (nextPagination) {
          paginationContainer.innerHTML = nextPagination.innerHTML;
          syncButtonUrl();
        } else {
          paginationContainer.innerHTML = "";
        }
      }

      // עדכון UI
      applyView();
      updateCountText();

    } catch (error) {
      console.error("Load more error:", error);

      // שחזור הכפתור רק אם הוא עדיין אותו כפתור ולא הוחלף
      const currentBtn = getButton();
      if (currentBtn) currentBtn.innerHTML = originalHTML;

    } finally {
      isLoading = false;

      // הורדת מצב טעינה מהכפתור הנוכחי שקיים בדף
      const currentBtn = getButton();
      if (currentBtn) {
        currentBtn.classList.remove("is-loading");
        currentBtn.removeAttribute("aria-busy");
      }
    }
  };

  // --- אתחול והאזנות ---
  const init = () => {
    applyView();
    syncButtonUrl();
    updateCountText();

    // Delegation אחד לכל הלחיצות
    document.addEventListener("click", (e) => {
      const loadBtn = e.target.closest('[data-load-more-trigger]');
      if (loadBtn) {
        loadMoreProducts(e);
        return;
      }

      const viewBtn = e.target.closest(".view-btn");
      if (viewBtn) {
        localStorage.setItem(VIEW_KEY, viewBtn.dataset.view);
        applyView();
      }
    }, { passive: false });

    // סינון AJAX של שופיפיי
    document.addEventListener("shopify:section:load", (e) => {
      if (e.target && e.target.id && e.target.id.includes("main-collection")) {
        applyView();
        syncButtonUrl();
        updateCountText();
      }
    });

    // גלילה
    if ("scrollRestoration" in history) history.scrollRestoration = "manual";
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
